"use strict";

import React from "react";
import Dispatcher from "./Dispatcher";
import Singleton from "./Singleton";
import Collection from "./Collection";

export {Dispatcher as Dispatcher};
export {Singleton as Singleton};
export {Collection as Collection};

export const types = {
	Dispatcher:	React.PropTypes.instanceOf(Dispatcher),
	Singleton:	React.PropTypes.instanceOf(Singleton),
	Collection:	React.PropTypes.instanceOf(Collection)
};

export default {Dispatcher, Singleton, Collection, types};


// WEBPACK FOOTER //
// ./~/vwa/flux/index.js